export default "__VITE_ASSET__ktWV3vjo__"